import { z } from 'zod';

/**
 * Mirrors apps/api/src/modules/identity/http/auth.dto.ts /
 * mfa.controller.ts exactly — same bounds, same field names.
 */
export const loginFormSchema = z.object({
  email: z.string().trim().toLowerCase().min(3).max(254).email('Adresse email invalide.'),
  password: z.string().min(8, 'Le mot de passe doit contenir au moins 8 caractères.').max(1024),
});
export type LoginFormValues = z.infer<typeof loginFormSchema>;
